import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer.component';


import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LegalModule } from '../legal/legal.module';
import { PrivacityModule } from '../privacity/privacity.module';
import { BrowserModule } from '@angular/platform-browser';
import { OfferModule } from '../offer-ence/offer.module';
import { TextoComprasModule } from '../texto-compras/textocompras.module';




@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        LegalModule,
        OfferModule,
        TextoComprasModule,
        PrivacityModule,
        AngularFontAwesomeModule,
        RouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports: [
        FooterComponent
    ],
  
    declarations: [
        FooterComponent
    ],
    providers: [
      
    ],
    entryComponents: [
        FooterComponent,
    ],
  
  })
  export class FooterModule { }

    // required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }